import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ds-card-eyebrow',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="ds-card-eyebrow"><ng-content /></div>`,
  styles: [`
    .ds-card-eyebrow {
      font-family: var(--f-mono);
      font-size: 11px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #CC2831;

      :where(.dark) & {
        color: #FF6B6B;
      }
    }
  `],
})
export class DsCardEyebrowComponent {}
